import { AUTH_ROUTE } from "./auth";
import { CATE_POST_ROUTE } from "./cate-post";
import { FILE_ROUTE } from "./file";
import { INVENTORY_ROUTER } from "./inventory";
import { LEAD_ROUTE } from "./lead";
import { MEDIA_ROUTE } from "./media";
import { POST_ROUTE } from "./post";
import { TAG_ROUTE } from "./tag";

export const ROUTE_API = {
  AUTH_ROUTE,
  FILE_ROUTE,
  INVENTORY_ROUTER,
  POST_ROUTE,
  CATE_POST_ROUTE,
  LEAD_ROUTE,
  TAG_ROUTE,
  MEDIA_ROUTE,
};
